import z from "zod";

export const getCalculationParamSchema = z.object({
	calculationId: z.uuid(),
});

export type GetCalculationParamSchema = z.infer<typeof getCalculationParamSchema>;
